import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import { BRAND } from '../config';
import './Sessions.css';

const Prizes = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [prizes, setPrizes] = useState([]);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    loadPrizes();
  }, []);

  const loadPrizes = async () => {
    setLoading(true);
    try {
      const response = await api.get('/admin/prizes', {
        params: { brand: BRAND }
      });
      setPrizes(response.data);
    } catch (error) {
      console.error('Error loading prizes:', error);
      setMessage({ type: 'error', text: 'Erreur lors du chargement des lots' });
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const handleBack = () => {
    navigate('/dashboard');
  };

  if (loading) {
    return (
      <div className="sessions-container">
        <div className="loading-screen">
          <div className="spinner-border" role="status" style={{ color: '#1565c0' }}></div>
          <p>Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="sessions-container">
      <div className="sidebar">
        <div className="sidebar-header">
          <div className="sidebar-logo-circle">
            <img src="/images/logo-supermont.png" alt="Supermont" style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: "50%" }} />
          </div>
          <h3>Les Perles de Vie</h3>
          <p className="sidebar-subtitle">Supermont</p>
        </div>

        <nav className="sidebar-nav">
          <button className="nav-item" onClick={() => navigate('/dashboard')}>
            <i className="fas fa-arrow-left"></i>
            <span>Retour Dashboard</span>
          </button>
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <i className="fas fa-user-circle"></i>
            <span>{user?.username}</span>
          </div>
          <button onClick={handleLogout} className="logout-btn">
            <i className="fas fa-sign-out-alt"></i>
            Déconnexion
          </button>
        </div>
      </div>

      <div className="main-content">
        <header className="content-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <button className="btn-back" onClick={handleBack}>
              <i className="fas fa-arrow-left"></i>
              Retour
            </button>
            <h1>Lots</h1>
          </div>
          <p className="brand-badge">Supermont</p>
        </header>

        {message.text && (
          <div className={`alert alert-${message.type}`}>
            {message.text}
          </div>
        )}

        <div className="sessions-grid">
          {prizes.length === 0 ? (
            <div className="empty-state">
              <i className="fas fa-gift" style={{ fontSize: '64px', color: '#1565c0', marginBottom: '20px' }}></i>
              <h3>Aucun lot</h3>
              <p>Il n'y a aucun lot configuré pour le moment.</p>
            </div>
          ) : (
            prizes.map((prize) => (
              <div key={prize.id} className="session-card">
                <div className="card-header">
                  <div className="card-icon">
                    <i className="fas fa-gift" style={{ color: '#fff', fontSize: '20px' }}></i>
                  </div>
                  <h2>{prize.name || `Lot ${prize.id}`}</h2>
                </div>
                <div className="card-body">
                  <div className="session-info">
                    <div className="info-row">
                      <span className="info-label">Type :</span>
                      <span className="info-value">{prize.type || '-'}</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Description :</span>
                      <span className="info-value">{prize.description || '-'}</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Probabilité :</span>
                      <span className="info-value">{prize.probability || 0}%</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Quota journalier :</span>
                      <span className="info-value">{prize.daily_quota || 'Illimité'}</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Statut :</span>
                      <span className="status-badge" style={{
                        background: prize.is_active ? '#e8f5e8' : '#e3f2fd',
                        color: prize.is_active ? '#228b22' : '#1565c0'
                      }}>
                        {prize.is_active ? 'Actif' : 'Inactif'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Prizes;
